'use client'
import { useEffect, useRef, useState } from 'react'
import { RaRichText } from '@components/core/index.core'

import { useIntersectionObserver } from '@utilities/hooks/useIntersectionObserver.hooks'

import styles from './ra-trustpilot.module.scss'

export const RaTrustpilot = ({ html }) => {
  const tpWrapper = useRef(null)
  const { hasIntersected } = useIntersectionObserver(tpWrapper)
  const [initialized, setInitialized] = useState(false)
  let attempts = 0

  const retry = () => {
    if (initialized) return null
    if (attempts > 3) return null
    setTimeout(() => {
      const tp = tpWrapper.current.querySelector('.trustpilot-widget')
      if (tp && tp.querySelector('iframe')) {
        setInitialized(true)
      } else {
        initTrustpilot()
      }
    }, 1500)
  }

  const initTrustpilot = async () => {
    attempts++
    const Trustpilot = (window as any).Trustpilot
    if (initialized) return
    if (!tpWrapper.current) return
    if (!Trustpilot) {
      retry()
      return
    }
    const tp = tpWrapper.current.querySelector('.trustpilot-widget')
    if (tp) {
      Trustpilot.loadFromElement(tp)
      if (!initialized) {
        retry()
      }
    }
  }

  useEffect(() => {
    if (hasIntersected && !initialized) {
      initTrustpilot()
    }
  }, [hasIntersected, initialized])

  return (
    <div
      ref={tpWrapper}
      className={styles['ra-trustpilot']}>
      <RaRichText content={html} />
    </div>
  )
}
